<bodyanalytics-main-nav style="margin-right: auto" />
@if (!isAuth()){
<bodyanalytics-login-button />
<bodyanalytics-signup-button />
} @else {
<bodyanalytics-logout-button />
}
